import React from "react";
import SVG from "react-inlinesvg";

import Modal from '@app/components/ui/modals/Modal'
import leaveImage from '@src/images/landing/leave';


const LeaveModal = ({ modal, onStay, onLeave }) => {
  return (
    <Modal
      ref={modal}
      className="leave-modal"
      closeButton={false}>
      <div className="leave-modal__inner">
        <div className="leave-modal__icon">
          <SVG src={leaveImage} />
        </div>
        <h2 className="leave-modal__header">
          Do you want to leave?
        </h2>
        <p className="leave-modal__hint">
          You still have time to solve tasks.
        </p>
        <div className="modal-content__buttons w-flex-layout w-flex-layout--columns mb-0">
          <button
            className="btn btn--blue btn--md mb-0"
            onClick={onStay}>
            SOLVE TASKS
          </button>
          <button
            className="btn btn--light-blue btn--md"
            onClick={onLeave}>
            LEAVE NOW
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default LeaveModal;